import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { gql, useMutation } from '@apollo/client';

const GET_FOLLOWING_USERS = gql`
  mutation Authorize($token: String!) {
    authorize(
      input: {token: $token}
    ) {
      user {
        followings {
          uuid
          username
          display_name
        }
      }
    }
  }
`;

const UNFOLLOW_USER = gql`
  mutation UnfollowUser($token: String!, $username: String!){
    unfollowUser(
      input: {
        token: $token
        username: $username
      }
    ) {
      status
      message
    }
  }
`;

function FollowingSection({ token }) {
  const [followMessage, setFollowMessage] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [followingUsers, setFollowingUsers] = useState([]);
  const [unfollowUsername, setUnfollowUsername] = useState(null);

  const [fetchFollowing] = useMutation(GET_FOLLOWING_USERS, {
    variables: { token },
    onCompleted: (d) => {
      setFollowingUsers(d.authorize.user.followings);
    }
  });

  useEffect(() => {
    fetchFollowing().finally();
  }, []);

  useEffect(() => {
    if (followMessage) {
      setTimeout(() => {
        setFollowMessage(null);
      }, 5000);
    }
  }, [followMessage]);

  useEffect(() => {
    if (errorMessage) {
      setTimeout(() => {
        setErrorMessage(null);
      }, 5000);
    }
  }, [errorMessage]);

  const [unfollowUser] = useMutation(UNFOLLOW_USER, {
    onCompleted: (d) => {
      setFollowMessage(d.unfollowUser.message);
      setFollowingUsers(followingUsers.filter((user) => user.username !== unfollowUsername));
      setUnfollowUsername(null)
    },
    onError: () => {
      setErrorMessage('There was an error when trying to unfollow that user.');
    },
  });

  const onUnfollow = (username) => {
    setUnfollowUsername(username);
  }

  useEffect(() => {
    if (unfollowUsername && window.confirm('Are you sure you want to unfollow this user?')) {
      unfollowUser({ variables: { token, username: unfollowUsername } }).finally();
    } else {
      setUnfollowUsername(null);
    }
  }, [unfollowUsername]);

  const hasFollowingUsers = followingUsers.length || -1 > 0;

  return (
    <div>
      <div>
        <h2 className="py-3">Following Users</h2>
      </div>
      <div>
        {followMessage && (
          <div className="alert alert-success alert-dismissible fade show" role="alert">
            <strong>Success!</strong> {followMessage}
            <button
              type="button"
              className="close"
              data-dismiss="alert"
              aria-label="Close"
              onClick={() => setFollowMessage(null)}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        )}
        {errorMessage && (
          <div className="alert alert-danger alert-dismissible fade show" role="alert">
            <strong>Something went wrong!</strong> {errorMessage}
            <button
              type="button"
              className="close"
              data-dismiss="alert"
              aria-label="Close"
              onClick={() => setErrorMessage(null)}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        )}
      </div>
      {!hasFollowingUsers ? (
        <div>No following users</div>
      ) : (
        <table className="table table-sm">
          <tbody>
          {followingUsers?.map(({ uuid, username, display_name: displayName }) => {
            return (
              <tr key={`following-${uuid}`}>
                <td>{displayName}</td>
                <td className="text-right">
                  <button
                    className="btn btn-sm btn-info"
                    onClick={() => onUnfollow(username)}
                  >
                    Unfollow
                  </button>
                </td>
              </tr>
            );
          })}
          </tbody>
        </table>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    token: state.auth.commentToken,
  };
};

FollowingSection.propTypes = {
  token: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(FollowingSection);
